import { createFileRoute } from "@tanstack/react-router";
import { ScribePage } from "shared/components/global/Scribe/ScribePage";

/** @public */
export const Route = createFileRoute("/_auth/help/organization")({
    component: () => <ScribePage src="https://scribehow.com/page-embed/Organization_Management__2gNCH8etRPWMnPa6b2IXaQ" />,
});
